import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { errMsg } from "@/lib/api";
import { savePrep } from "@/lib/recruiter";

const SHARE = [["profile", "Profile & career goals"], ["resume", "Current resume"], ["applications", "Job applications & search activity"], ["interviews", "Recent interview practice"], ["past_notes", "Notes from earlier consultations"], ["wellbeing", "Well-Being check-in trends"]];
const DEFAULT = { profile: true, resume: true, applications: true, interviews: true, past_notes: true, wellbeing: false };

export const PrepForm = ({ me, onSaved }) => {
  const [q, setQ] = useState(me.prep?.questions || "");
  const [c, setC] = useState({ ...DEFAULT, ...(me.consent || {}) });
  const [busy, setBusy] = useState(false);
  useEffect(() => { setQ(me.prep?.questions || ""); setC({ ...DEFAULT, ...(me.consent || {}) }); }, [me]);
  const save = async () => {
    setBusy(true);
    try { await savePrep({ questions: q, consent: c, appointment_id: me.upcoming?.[0]?.id || null }); toast.success("Saved. Your recruiter gets a short briefing before the call."); onSaved?.(); }
    catch (e) { toast.error(e.response?.status === 404 ? "Saving prep isn't live yet. Bring your questions to the call." : errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-4 rounded-2xl border border-[#27272A] bg-[#121214] p-5" data-testid="recruiter-prep">
      <div><p className="font-display text-lg text-zinc-100">Prepare for your call</p><p className="text-xs text-zinc-500">Before the call we write your recruiter a short briefing. It only uses what you allow below.</p></div>
      <Textarea rows={3} value={q} onChange={(e) => setQ(e.target.value)} placeholder="What do you want answered? e.g. Why am I not getting interviews for senior PM roles?" className="bg-[#09090B]" data-testid="recruiter-prep-questions" />
      <div className="space-y-2">{SHARE.map(([k, l]) => (
        <label key={k} className="flex items-center justify-between gap-3 rounded-lg border border-[#1f1f23] px-3 py-2 text-sm text-zinc-300">
          <span>{l}{k === "wellbeing" && <span className="block text-[11px] text-zinc-500">Off unless you turn it on. Journal entries are never shared.</span>}</span>
          <Switch checked={!!c[k]} onCheckedChange={(v) => setC((s) => ({ ...s, [k]: v }))} data-testid={`recruiter-consent-${k}`} />
        </label>
      ))}</div>
      <div className="flex items-center justify-between gap-2"><p className="flex items-center gap-1.5 text-[11px] text-zinc-500"><ShieldCheck className="h-3.5 w-3.5 text-emerald-400" />You can change this any time.</p>
        <Button onClick={save} disabled={busy} className="bg-[#8224e3] text-white hover:bg-[#9440f0]" data-testid="recruiter-prep-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />}Save</Button></div>
    </div>
  );
};
